import { NODE_WIDTH } from '../../../../../utils/dimensions';

enum DIRECTION {
  LEFT = -1,
  RIGHT = 1,
}

export const getSmoothStepLoopPath = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  radius,
  sourceOffset,
  targetOffset,
}: {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  radius: number;
  sourceOffset: number;
  targetOffset: number;
}) => {
  const direction = sourceX - targetX <= 0 ? DIRECTION.LEFT : DIRECTION.RIGHT;
  const distance =
    direction === DIRECTION.LEFT ? 0 : NODE_WIDTH - radius * 2 + 20;

  const X1 = sourceX;
  const X2 = X1 + radius * direction;
  const X3 = X2 + distance * direction;
  const X4 = X2 + (distance * direction + radius * direction);
  const X5 = targetX + radius * direction;
  const X6 = targetX;

  const Y1 = sourceY;
  const Y2 = Y1 + sourceOffset;
  const Y3 = Y2 + radius;
  const Y4 = targetY - targetOffset;
  const Y5 = Y4 - radius;
  const Y6 = targetY;

  const START = `M ${X1}, ${Y1}`;
  const LINE_1 = `L ${X1}, ${Y2}`;
  const CORNER_1 = `Q ${X1}, ${Y3} ${X2}, ${Y3}`;
  const LINE_2 = `L ${X3}, ${Y3}`;
  const CORNER_2 = `Q ${X4}, ${Y3} ${X4}, ${Y2}`;
  const LINE_3 = `L ${X4}, ${Y4}`;
  const CORNER_3 = `Q ${X4}, ${Y5} ${X3}, ${Y5}`;
  const LINE_4 = `L ${X5}, ${Y5}`;
  const CORNER_4 = `Q ${X6}, ${Y5} ${X6}, ${Y4}`;
  const LINE_5 = `L ${X6}, ${Y6}`;

  return (
    START +
    LINE_1 +
    CORNER_1 +
    LINE_2 +
    CORNER_2 +
    LINE_3 +
    CORNER_3 +
    LINE_4 +
    CORNER_4 +
    LINE_5
  );
};
